
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sdq3_19f3o_99",
  "input": "awsui_input_1sdq3_19f3o_137",
  "results": "awsui_results_1sdq3_19f3o_141"
};
  